<template>
  <v-dialog v-model="showDialog" width="400" persistent>
    <v-card class="secondary">
      <v-card-title class="primary white--text"> Confirmation </v-card-title>
      <v-card-text class="mt-4">
        <div class="subtitle-2">
          Are you sure want to
          {{ active ? "deactivate" : "activate " }} this {{ name }} {{ title }}?
        </div>
      </v-card-text>
      <v-card-actions class="mt-n3 d-flex justify-end">
        <v-btn text color="green" @click="$emit('delete')">Yes</v-btn>
        <v-btn text color="red" @click="$emit('close')">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: this.show,
    };
  },
};
</script>

<style></style>
